import {
  UPLOAD_CANCELATION_FILE,
  UPLOAD_CANCELATION_FILE_SUCCESS,
  UPLOAD_CANCELATION_FILE_ERROR,
  UPLOAD_CANCELATION_FILE_EMPTY,
} from '../../../../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const UploadCancelationFile = (state = initialState, action) => {
  switch (action.type) {
    case UPLOAD_CANCELATION_FILE:
      state = {
        ...state,
        data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case UPLOAD_CANCELATION_FILE_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case UPLOAD_CANCELATION_FILE_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case UPLOAD_CANCELATION_FILE_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default UploadCancelationFile;
